import { lastMonths, monthLabel } from "./months";

/** The last twelve months, newest first. A month named in the URL that has
 *  fallen off the end stays selectable so a bookmarked link still works. */
export function MonthPicker({
  month,
  onChange,
}: {
  month: string;
  onChange: (m: string) => void;
}): JSX.Element {
  const options = lastMonths();
  if (!options.includes(month)) options.push(month);
  return (
    <label style={{ fontSize: 14 }}>
      Month{" "}
      <select value={month} onChange={(e) => onChange(e.target.value)}>
        {options.map((m) => (
          <option key={m} value={m}>
            {monthLabel(m)}
          </option>
        ))}
      </select>
    </label>
  );
}
